<template>
  <div class="container">
    <div class="navbar_style">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.account_info }}</span>
      <div class="icon_box"></div>
    </div>

    <div class="bankCard_footer">
      <div class="bankCard_btn" @click="navto">
        {{ l.bank_nav_bar_title }}
        <img src="@/assets/order/arrowright.png"/>
      </div>
    </div>
    <div class="bankCard_middle">
      <div
          v-for="(item, index) in cardList"
          :key="index"
          class="bankCard_box"
      >
        <div class="bankCard_first">
          <div class="bankCard_left">
            {{ item.bankName }}
          </div>
          <div class="bankCard_right">
            <div
                :class="curIndex == index && 'bankCard_item_select'"
                class="bankCard_item"
                @click="selectDefault(item, index)"
            >
              <img
                  v-if="curIndex == index"
                  mode=""
                  src="@/assets/bankcard/hook2.png"
              />
              <img
                  v-if="curIndex != index"
                  mode=""
                  src="@/assets/bankcard/hook.png"
              />
            </div>
          </div>
        </div>
        <div class="bankCard_second">
          {{ formatCardNo(item.cardNo) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Icon} from "vant";
import l from "../../locales";
import {queryCardList, setDefault} from "@/services/information";

export default {
  data() {
    return {
      curIndex: 0,
      cardList: undefined,
      l: {...l.router, ...l.bankCard},
    };
  },
  components: {Icon},
  created() {
    this.init();
  },
  methods: {
    async init() {
      console.log("1111")
      let cardList = await queryCardList();
      this.cardList = cardList.result;
      // this.cardList.push(...this.cardList);
      // this.cardList.push(...this.cardList);
      // this.cardList.push(...this.cardList);
      this.curIndex = this.cardList.findIndex((v) => v.usedStatus == 1);
      if (this.cardList.length == 0) {
        this.$router.back(1);
      }
    },
    navto() {
      this.$router.push({path: "/addcard", query: {busiId: this.$route.query.busiId}});
    },
    formatCardNo(str) {
      str = str
          .split("")
          .map((v, k) => (v = k != str.length - 5 ? v : v + ","))
          .join("");
      let strArr = str.split(",");
      strArr[0] = strArr[0]
          .split("")
          .map(() => "X")
          .join("");
      str = strArr.join("");
      return str.replace(/[X]{2}[X]{4}/, "XX XXXX ");
    },
    async selectDefault(item, index) {
      let params = {
        // ...item,
        bank_code: item.bankCode,
        card_hold_name: item.cardHoldName,
        card_no: item.cardNo,
        card_phone: item.phone,
        busiNo: this.$route.query.busiId,
      };
      let res = await setDefault(params);
      if (res.code == 200) {
        this.curIndex = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #F8FBFF;


  .bankCard_middle {
    height: 100%;
    overflow: auto;

    .bankCard_box {
      position: relative;
      border-radius: 15px;
      box-sizing: border-box;


      background: url("../../assets/bankcard/card.png") no-repeat;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      margin: 20px auto;
      margin-top: 0;
      padding: 26px 30px;
      padding-top: 66px;
      padding-right: 20px;
      height: 151px;
      width: 301px;
      box-sizing: border-box;


      .bankCard_first {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bankCard_left {

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #555555;


        }

        .bankCard_right {
          position: absolute;
          top: 15px;
          right: 15px;
          width: fit-content;
          display: flex;
          align-items: center;
          justify-content: flex-end;


          .bankCard_item {
            box-sizing: border-box;
            //border-radius: 2px;
            //border: 1px solid #ffffff;

            img {
              margin-right: 4px;
              width: 18px;
              height: 18px;
            }
          }

          .bankCard_item_select {
            border: none;
          }
        }
      }

      .bankCard_second {
        margin-top: 10px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #555555;


      }
    }
  }

  .bankCard_footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .bankCard_btn {
    position: relative;
    overflow: hidden;

    margin: 20px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #0090C2;
    text-align: right;


    img {
      width: 16px;
      height: 16px;
      margin-left: 5px;
    }
  }

  .bankCard_btn:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-img: radial-gradient(circle, #666 10%, transparent 60%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform 0.8s, opacity 0.8s;
  }

  .bankCard_btn:active:after {
    transform: scale(0, 0);
    opacity: 0.1;
    transition: 0s;
  }
}
</style>
